<div class="container"
     [style.right]="right + 'px'"
     [style.bottom]="bottom + 'px'">
    <div *ngIf="displayMode == 'fab'"
         class="fab-action">
        <button mat-fab
                [matTooltip]="title | translate"
                matTooltipPosition="above"
                [disabled]="isLoading || disabled"
                [color]="color"
                (click)="onClicked()">
            <mat-icon>{{ icon }}</mat-icon>
        </button>
        <mat-spinner *ngIf="isLoading"
                     [mode]="'indeterminate'"
                     [color]="'accent'"
                     [diameter]="72">
        </mat-spinner>
    </div>
    <div *ngIf="displayMode == 'button'"
         class="button-action">
        <button mat-raised-button
                [color]="color"
                [disabled]="isLoading || disabled"
                (click)="onClicked()">
            <mat-icon *ngIf="icon && !isLoading">
                {{ icon }}
            </mat-icon>
            <mat-spinner *ngIf="isLoading"
                         [mode]="'indeterminate'"
                         [color]="'accent'"
                         [diameter]="24">
            </mat-spinner>
            <span>{{ title | translate }}</span>
        </button>
    </div>
</div>